export const SELECT_PLAYER = 'SELECT_PLAYER';
export const SELECT_MANAGER = 'SELECT_MANAGER';

export const GET_GAME_JSON_REQUEST = 'GET_GAME_JSON_REQUEST'
export const GET_GAME_JSON_SUCCESS = 'GET_GAME_JSON_SUCCESS'

export const MOVE_TO_NEXT_EVENT = 'MOVE_TO_NEXT_EVENT'
export const MOVE_TO_NEXT_EPISOD = 'MOVE_TO_NEXT_EPISOD'
export const MOVE_TO_PREV_EPISOD = 'MOVE_TO_PREV_EPISOD'
export const SET_THEME = 'SET_THEME'
export const MOVE_TO_EVENT = 'MOVE_TO_EVENT'
export const START_GAME = 'START_GAME'
export const PAUSE_GAME = 'PAUSE_GAME'
export const REQUEST_REPLAY = 'REQUEST_REPLAY'
export const SPEED_UP_GAME = 'SPEED_UP_GAME'
export const TOGGLE_SOUND = 'TOGGLE_SOUND'
export const SLOW_DOWN_GAME = 'SLOW_DOWN_GAME'
export const MOVE_TO_MINUTE = 'MOVE_TO_MINUTE'
export const SET_GAME_SPEED = 'SET_GAME_SPEED'
export const START_REPLAY = 'START_REPLAY'
export const END_REPLAY = 'END_REPLAY'

export const SHOW_STATS_SELECTOR = 'SHOW_STATS_SELECTOR'
export const CLOSE_STATS_SELECTOR = 'CLOSE_STATS_SELECTOR'

export const HIGHLIGHT_PLAYERS = 'HIGHLIGHT_PLAYERS'

export const START_SCENE = 'START_SCENE'
export const END_SCENE= 'END_SCENE'

export const CHANGE_WINDOW_POSITION = 'CHANGE_WINDOW_POSITION'
export const CHANGE_WINDOW_SIZE = 'CHANGE_WINDOW_SIZE'
export const TOGGLE_CUT_DOWN_WINDOW = 'TOGGLE_CUT_DOWN_WINDOW'

export const SHOW_STATS_WINDOW = 'SHOW_STATS_WINDOW'
export const CLOSE_STATS_WINDOW = 'CLOSE_STATS_WINDOW'
export const TOGGLE_SETTINGS_WINDOW = 'TOGGLE_SETTINGS_WINDOW'
export const TOGGLE_ABOUT_WINDOW = 'TOGGLE_ABOUT_WINDOW'
export const TOGGLE_DONATE_WINDOW = 'TOGGLE_DONATE_WINDOW'

export const MOVE_TO_START = 'MOVE_TO_START'


export const CONNECT_TO_CHAT = 'CONNECT_TO_CHAT'
export const RECIEVE_MESSAGES = 'RECIEVE_MESSAGES'
export const UPDATE_CHANNELS = 'UPDATE_CHANNELS'
export const UPDATE_USERS = 'UPDATE_USERS'
export const CHANGE_CHANNEL = 'CHANGE_CHANNEL'



/** WEBPACK FOOTER **
 ** ./src/constants/ActionTypes.js
 **/